export default __webpack_public_path__ + "static/media/dark-solana-logo.fa522d66.svg";